'use client';

import { BaseCarousel } from 'components/shared/Carousel/BaseCarousel';
import { CarouselOptions } from 'types/sharedComponents';
import { PropsWithChildren } from 'react';
import { useBreakpoint } from 'hooks/useBreakpoints';

interface CarouselProps extends PropsWithChildren {
  totalItems: number;
}

const TeaserLinkCarousel = ({ totalItems, children }: CarouselProps) => {
  const { isAboveMd } = useBreakpoint('md');
  const getResponsiveThreshold = () => {
    return isAboveMd ? 4 : 1;
  };

  const carouselOpts: CarouselOptions = {
    align: 'start',
    loop: false,
    slidesToScroll: 1,
    containScroll: false,
    watchDrag: totalItems > getResponsiveThreshold(),
  };

  return (
    <BaseCarousel
      aria-label="Teaser links carousel"
      totalItems={totalItems}
      carouselClassName={'relative flex overflow-hidden'}
      carouselPaginationClassName="mt-8"
      carouselContentClassName="w-full"
      carouselOpts={carouselOpts}
      showPaginationThreshold={getResponsiveThreshold()}>
      <div className="grid grid-rows-1 md:auto-cols-[calc(25%-35px)] sm:auto-cols-[calc(33%-40px)] auto-cols-[calc(100%-60px)] grid-flow-col sm:gap-6 gap-2">
        {children}
      </div>
    </BaseCarousel>
  );
};

export default TeaserLinkCarousel;
